import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActionArea,
} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import ShareIcon from '@mui/icons-material/Share';
import EventIcon from '@mui/icons-material/Event';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { config } from '../../../utils/config';

export interface LCMoreProps {
  id: string;
  localChapterAccess?: boolean;
  appPilotProgram?: boolean;
}

const LCMore: React.FC<LCMoreProps> = ({
  id,
  localChapterAccess,
  appPilotProgram,
}) => {
  const showCommittees = localChapterAccess && appPilotProgram;
  const showSocial = localChapterAccess && appPilotProgram;
  const showEvents =
    localChapterAccess && appPilotProgram && config.EVENTS_TAB_ENABLED;
  const showBylaws = localChapterAccess;

  const cards = [
    ...(showCommittees
      ? [
          {
            title: 'Committees',
            description: 'Manage chapter committees and members',
            to: `/local-chapters/${id}/committees`,
            icon: <GroupsIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
          },
        ]
      : []),
    ...(showSocial
      ? [
          {
            title: 'Social',
            description: 'Chapter social links and connections',
            to: `/local-chapters/${id}/social`,
            icon: <ShareIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
          },
        ]
      : []),
    ...(showEvents
      ? [
          {
            title: 'Events',
            description: 'View and manage chapter events',
            to: `/local-chapters/${id}/events`,
            icon: <EventIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
          },
        ]
      : []),
    ...(showBylaws
      ? [
          {
            title: 'Bylaws',
            description: 'View and edit chapter bylaws',
            to: `/local-chapters/${id}/bylaws`,
            icon: <MenuBookIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
          },
        ]
      : []),
  ];

  if (cards.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ py: 3 }}>
        No additional tools available for this chapter.
      </Typography>
    );
  }

  return (
    <Grid container spacing={2} sx={{ pt: 1 }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={4} key={card.title}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardActionArea
              component={RouterLink}
              to={card.to}
              sx={{ height: '100%', display: 'flex', alignItems: 'stretch' }}
            >
              <CardContent sx={{ width: '100%' }}>
                <Box sx={{ mb: 2 }}>{card.icon}</Box>
                <Typography variant="h6" component="h3" gutterBottom>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default LCMore;
